// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rolepermissionsdialog_featuredItem__WYkZn {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.rolepermissionsdialog_dialogInputs__HFKpO {
    width: 100%;
}

.rolepermissionsdialog_featuredTitleHeader__y2jcU {
    color: var(--hsrcDarkBlue);
    font-size: 16px;
    font-weight: bold;
}

.rolepermissionsdialog_featuredText__2fl9l {
    color: var(--hsrcDarkBlue);
    font-size: 14px;
    font-weight: normal;
}

.rolepermissionsdialog_table_header_cell__JAfNC {
    background-color: var(--hsrcMidGreen);
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/RolesManagement/RolePermissionsDialog/rolepermissionsdialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n\r\n.featuredText {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n}\r\n\r\n.table_header_cell {\r\n    background-color: var(--hsrcMidGreen);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `rolepermissionsdialog_featuredItem__WYkZn`,
	"dialogInputs": `rolepermissionsdialog_dialogInputs__HFKpO`,
	"featuredTitleHeader": `rolepermissionsdialog_featuredTitleHeader__y2jcU`,
	"featuredText": `rolepermissionsdialog_featuredText__2fl9l`,
	"table_header_cell": `rolepermissionsdialog_table_header_cell__JAfNC`
};
export default ___CSS_LOADER_EXPORT___;
